import { useEffect, useRef } from "react";
import type { ISkeletonLoader } from "libs/design-system/src/types/common/skeleton_loader";
import { SkeletonBase } from "./SkeletonBase";
import styles from "./skeleton-loader.module.scss";

const calculateChildHeight = (height: string, divisor: number, multiplier?: number): string => {
  const match = height.match(/^(\d+(\.\d+)?)(px|rem|%)$/);
  const multiply = multiplier ?? 1;

  if (match) {
    // Skipping the first item which is the full match and the third item which is the decimals
    const [_, value, , unit] = match;
    const newValue = (parseFloat(value) / divisor) * multiply;
    return `${newValue > Number(value) ? value : newValue}${unit}`;
  }
  return height;
};

export const SkeletonLoader = ({
  type = 'bordered_box',
  width = "100%",
  height = "100%",
  noOfRows = 5
}: ISkeletonLoader) => {

  const containerRef = useRef<any>(null);

  const rowsNumber = Math.floor(noOfRows) || 1;

  useEffect(() => {
    containerRef.current && containerRef.current.style.setProperty("--child-count", noOfRows);
  }, [noOfRows]);

  return (
    <div
      className={styles["skeleton-loader"]}
      style={{ width, height }}
      ref={containerRef}
      data-skeleton-loader-type={type}
    >
      {
        type === "bordered_box" &&
        <SkeletonBase key={`skeleton-base-main`} height={calculateChildHeight(height, rowsNumber, 1.5)} />
      }
      {
        Array.from({ length: type === 'bordered_box' ? (rowsNumber - 1) : rowsNumber }).map((_, i: number) =>
          <SkeletonBase
            key={`skeleton-base-${i}`}
            height={calculateChildHeight(height, rowsNumber)}
          />
        )
      }

    </div>
  )
};